<template>
  <div class="container main-container">
    <div class="align-items-center justify-content-center text-center">
      <hr class="my-1" />
      <h1 class="display-5">Herzlich willkommen bei Fabi Imbiss <br> Dein Döner in Winti</h1>
      <div class="row justify-content-center">
        <h5>Bisch vo Winti?</h5>
      </div>
      <div class="row justify-content-center">
        <h5>Mer hend brutali Kebap</h5>
      </div>
      <div class="row justify-content-center">
        <h5>De Brot machemer jede Tag selber, isch aso sehr frisch</h5>
      </div>
      <div class="row justify-content-center">
        <h5>Ich habe set über 10 Jahr nur Pizza gmacht</h5>
      </div>
      <div class="row justify-content-center">
        <h5>Muesch aso nechscht mal unbedingt Pizza probiere, isch au brutal</h5>
      </div>
      <div class="row justify-content-center">
        <h5>Getränk chasch selber neh, wie dihei</h5>
      </div>
      <hr class="my-1" />
            <div class="row justify-content-center">
      <h3 class="display-5" id="socialFooter" >Folge uns auf folgenden Platformen</h3>
      </div>
      <div class="row justify-content-center">
        <a href="https://www.facebook.com/fabiimbiss/">
          <img src="../assets/facebookIcon.png" alt />
        </a>
        <a href="https://www.instagram.com/fabiimbiss/?igshid=tjrvc6qhgakf">
          <img src="../assets/instaIcon.png" alt />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StartPage",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h3, h5{
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}
h5{
  padding: 2px;
}
.main-container{
  height: 100%;
  background-image: url(../assets/wintiWappen.png);
  background-color: #191919;
  color: whitesmoke;
}
#socialFooter{
  margin-top: 30px;
}
h1{
  margin-top: 20px;
  margin-bottom: 30px;
}
img{
  padding: 0px 10px;
}
@media only screen 
    and (max-width : 600px) {
   h1{
  font-size: 22px;
}
 h3{
  font-size: 22px;
}
 h5{
  font-size: 16px;
}
img{
  width: 75%;
}
     }
     @media only screen 
    and ( max-width : 800px)
    and ( min-width : 601px) {
   h1{
  font-size: 24px;
}
 h3{
  font-size: 24px;
}
 h5{
  font-size: 18px;
}
     }
</style>
